<template>
  <div class="gray_block">
    <div>
      <div class="inner_gray_block">
        <div class="text mb-30 desc-text" :style="`color: ${color};`">
          Ürünlerini içeren fişinin fotoğrafını çekmelisin. Aşağıdaki bilgilerin açıkça görülebildiğinden emin ol.
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-7">
          <ul class="wraper_punkt">
            <li class="media" :key="step.label" v-for="step in steps">
              <div class="media-body item_text" :style="`color: ${color};`">
                <b>{{ step.label }}</b>. {{ step.text }}
              </div>
            </li>
          </ul>
        </div>
        <div class="col-5">
          <img class="img-fluid" src="../assets/img/png/cash.png" alt="" />
        </div>
      </div>
      <div v-if="disclaimer">
        <span v-html="disclaimer" />
      </div>
      <div class="wrapper_check_block clearfix">
        <div class="checkMark">
          <img class="img-fluid" src="../assets/img/png/check_1.png" alt="" />
          <img class="checkMark_img checkMark_img_1" src="../assets/img/svg/checkMark.svg" alt="" />
        </div>
        <div class="checkMark">
          <img class="img-fluid" src="../assets/img/png/check_2.png" alt="" />
          <img class="cross_red_img cross_red_img_2" src="../assets/img/svg/cross_red.svg" alt="" />
        </div>
        <div class="checkMark">
          <img class="img-fluid" src="../assets/img/png/check_3.png" alt="" />
          <img class="cross_red_img cross_red_img_3" src="../assets/img/svg/cross_red.svg" alt="" />
        </div>
        <div class="checkMark">
          <img class="img-fluid" src="../assets/img/png/check_4.png" alt="" />
          <img class="cross_red_img cross_red_img_4" src="../assets/img/svg/cross_red.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'receipt-information',
  props: {
    descriptionText: {
      required: false,
      type: String,
      default: ''
    },
    steps: {
      required: false,
      type: [Array, Object],
      default: () => [
        {
          'text': 'Satış noktası',
          'label': 'A'
        },
        {
          'text': 'Satın alma tarihi ve saati',
          'label': 'B'
        },
        {
          'text': 'Ürünler ve satın alma fiyatları',
          'label': 'C'
        },
        {
          'text': 'Toplam fiş/fatura ve KDV tutarı',
          'label': 'D'
        },
        {
          'text': 'Fiş/Fatura numarası',
          'label': 'E'
        }
      ]
    },
    color: {
      default: '#2B2D32'
    },
    disclaimer: String
  },
  data: () => ({
    pullDown: false
  }),
  computed: {
    shouldDisplayFull() {
      return screen.width > 992 ? true : false;
    }
  },
  methods: {
    pull() {
      this.pullDown = !this.shouldDisplayFull ? !this.pullDown : false;
    }
  }
};
</script>
<style lang="scss" scoped>
.desc-text {
  text-align: left;
  font-size: 18px;

  @media (max-width: 479px) {
    font-size: 17px;
  }

  @media (max-width: 400px) {
    font-size: 20px;
  }

  @media (max-width: 320px) {
    font-size: 14px;
  }
}

.gray_block {
  background-color: #F4F4F4;
  padding: 60px;
  border-radius: 4px;

  @media (max-width: 991px) {
    padding: 40px 60px;
  }

  @media (max-width: 767px) {
    padding: 40px 15px;
  }

  .inner_gray_block {
    text-align: left;
    margin-bottom: 50px;
  }
}

.wraper_punkt {
  margin-bottom: 30px;

  li {
    margin-bottom: 30px;
    font-size: 16px;
    letter-spacing: 0.16px;
    line-height: 19px;

    @media (max-width: 991px) {
      margin-bottom: 15px;
    }

    .item {
      width: 25px;
      height: 25px;
      display: inline-block;
      background: #8b8b8b;
      color: #2B2D32;
      border-radius: 100px;
      text-transform: uppercase;
      margin-right: 20px;
      text-align: center;
      padding: 3px 8px;
    }

    .item_text {
      // color: #fff;
      // font-family: Montserrat;
      font-size: 14px;
      font-weight: 500;
      display: inline-block;
    }
  }
}

.checkMark {
  position: relative;
  float: left;
  margin-left: 15px;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 11px 9px;

  &:first-child {
    margin-left: 0px;
  }

  .checkMark_img {
    position: absolute;
    top: 70px;
    left: 50%;
    margin-left: -18px;

    @media (max-width: 767px) {
      max-width: 24px;
      margin-left: -12px;
    }
  }

  .cross_red_img {
    position: absolute;
    top: 70px;
    left: 50%;
    margin-left: -18px;

    @media (max-width: 767px) {
      max-width: 24px;
      margin-left: -12px;
    }
  }
}

.wrapper_check_block {
  padding-top: 90px;
  display: flex;

  @media (max-width: 991px) {
    padding-top: 20px;
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.drop_down {
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  align-items: center;
  cursor: pointer;

  p {
    margin: 0px;

    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }

  img {
    width: 20px;
    height: 20px;
  }
}

.drop_down_wrapper {
  padding: 10px !important;
  // border-radius: 100px;
  margin-bottom: 20px !important;
}

@media all and (orientation: landscape) {
  .drop_down {
    display: flex;
    justify-content: space-evenly;
    align-content: center;
    align-items: center;
    cursor: pointer;

    p {
      margin: 0px;

      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  .drop_down_wrapper {
    padding: 10px !important;
    border-radius: 100px;
    margin-bottom: 20px !important;
  }

  @media screen and (max-width: 425px) {
    .stepCardWrapper {
      padding: 15px !important;
      margin-bottom: 200px !important;
      border-radius: 30px;
      height: 450px;
      background-color: white !important;
    }

    .drop_down {
      display: none;
    }
  }

  @media screen and (max-width: 375px) {
    .stepCardWrapper {
      font-size: 12px !important;
    }
  }
}
</style>
